import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { UnitCategory } from "@/types";

interface UnitTableCategoryFilterProps {
    categories: UnitCategory[];
    selectedCategories: number[];
    onSelectionChange: (categories: number[]) => void;
}

export const UnitTableCategoryFilter = ({
    categories,
    selectedCategories,
    onSelectionChange,
}: UnitTableCategoryFilterProps) => {
    const handleCheckboxChange = (category: number) => {
        const newCategories = selectedCategories.includes(category)
            ? selectedCategories.filter((c) => c !== category)
            : [...selectedCategories, category];
        onSelectionChange(newCategories);
    };

    if (categories.length === 0) {
        return null;
    }

    return (
        <div>
            <p className="tw:font-bold">By Size / Type</p>
            <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-x-4">
                {categories.map((category) => (
                    <div
                        key={category.id}
                        className="tw:items-start tw:flex tw:flex-row tw:space-x-3 tw:space-y-0 tw:py-1"
                    >
                        <Checkbox
                            id={category.slug}
                            onCheckedChange={() =>
                                handleCheckboxChange(category.id)
                            }
                            checked={selectedCategories.includes(category.id)}
                        />
                        <Label
                            htmlFor={category.slug}
                            className="tw:text-sm tw:font-normal tw:ml-2"
                        >
                            {category.name}
                        </Label>
                    </div>
                ))}
            </div>
        </div>
    );
};
